import React from 'react';
import {connect} from "react-redux";
import {ACTION_TYPES, actions} from "../../actions";
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Submission from '../helpers/Submission';

class ArtifactRow extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            swapped: false,
            isReviewed: true
        };
    };

    componentDidMount() {
        var reviewerObject = this.props.reviewers.filter(reviewer => {
            return reviewer.unid === this.props.user.unid;
        })
        let reviewer = reviewerObject[0];
        this.setState({isReviewed: !reviewer.finished})
    }

    getScore(artifact_id) {
        var reviewerObject = this.props.reviewers.filter(reviewer => {
            return reviewer.unid === this.props.user.unid;
        })
        let reviewer = reviewerObject[0];

        let artifactObject = reviewer.artifactScores.filter(artifact => {
            return artifact.artifact_id === artifact_id;
        })
        let artifact = artifactObject[0];

        let score = 0;

        let nullFiltered = artifact.rubricScores.filter(function (criteria_score) {
            return criteria_score != null;
        });

        if(nullFiltered.length == 0) {
            return 'Not Started';
        }

        let negativeFiltered = nullFiltered.filter(function(criteria_score){ return criteria_score > -1 });

        if(negativeFiltered.length == 0) {
            return 'Not Applicable';
        }

        score = negativeFiltered.reduce(function(a,b){return a+b});

        return score.toFixed(2);
    }

    render() {
        return (
            <TableRow key={this.props.row.canvas_assignment_id + '-' + this.props.row.canvas_user_id}>
                <TableCell component="th" scope="row">
                    {this.props.row.canvas_assignment_name}
                </TableCell>
                <TableCell>{this.props.row.submission_type}</TableCell>
                <TableCell>{this.props.row.course_code}</TableCell>
                <TableCell>{this.getScore(this.props.row.canvas_submission_id)}</TableCell>
                <TableCell>{this.props.row.canvas_submission_id}</TableCell>
                <TableCell><Submission submission={this.props.row} isReviewed={this.state.isReviewed}/></TableCell>
            </TableRow>
        );
    }

}

function mapStateToProps(state) {
    return {
        form: state.newAssessmentForm,
        artifacts: state.artifacts,
        user: state.user,
        reviewers: state.reviewers
    };
}

export default connect(mapStateToProps, actions)(ArtifactRow);
